import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ProskinsLogo from './ui/ProskinsLogo';
import LoginModal from './auth/LoginModal';
import RegisterModal from './auth/RegisterModal';
import NotificationBell from './notifications/NotificationBell';
import './Header.css';

const Header = () => {
  const { user, isAuthenticated, logout, loading } = useAuth();
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
  };

  const openLoginModal = () => {
    setIsLoginModalOpen(true);
    setIsRegisterModalOpen(false);
  };

  const openRegisterModal = () => {
    setIsRegisterModalOpen(true);
    setIsLoginModalOpen(false);
  };

  const closeLoginModal = () => setIsLoginModalOpen(false);
  const closeRegisterModal = () => setIsRegisterModalOpen(false);

  if (loading) {
    return (
      <header className="header">
        <div className="container">
          <div className="proskins-flex proskins-items-center proskins-justify-between">
            <ProskinsLogo size="large" showTagline={false} linkTo="/" />
            <div className="proskins-loading"></div>
          </div>
        </div>
      </header>
    );
  }

  return (
    <header className="proskins-header">
      <div className="row content">
      <div className="header-content">
        {/* Left Section: Logo + Navigation */}
        <div className="proskins-flex proskins-items-center proskins-justify-between">
            <div className="proskins-flex proskins-items-center proskins-gap-lg">
              <div className="proskins-header-logo">
                <ProskinsLogo size="large" showTagline={false} linkTo="/" />
              </div>

              <nav className="nav">
                {isAuthenticated && (
                  <>
                    <Link to="/tournaments" className="proskins-nav-link">Tournaments</Link>
                    <Link to="/betting" className="proskins-nav-link">Live Betting</Link>
                    {/* <Link to="/betting" className="proskins-nav-link">🎯 Live Betting</Link> */}
                  </>
                )}
              </nav>
            </div>
          </div>
          {/* Right Section: Icons + User Info + Logout */}
          <div className="auth-section">
            <div className="auth-buttons">
              {/* Notifications */}
              {isAuthenticated && <NotificationBell />}

              {/* User Icon */}
              {isAuthenticated ? (
                <Link to="/dashboard">
                  <img
                    className="headericon"
                    src={`${process.env.PUBLIC_URL}/usericon.png`}
                    alt="User"
                  />
                </Link>
              ) : (
                <Link to="/dashboard">
                  <img
                    className="headericon"
                    src={`${process.env.PUBLIC_URL}/usericon.png`}
                    alt="User"
                  />
                </Link>
              )}

              {/* Welcome text only for logged in */}
              {isAuthenticated && (
                <span className="welcome-text">Welcome, {user?.firstName}</span>
              )}

              {/* <h2 className="pipecolor"> | </h2> */}

              {/* Auth Actions */}
              {isAuthenticated ? (
                <img
                  className="headericon"
                  onClick={handleLogout}
                  src={`${process.env.PUBLIC_URL}/logouticon.png`}
                  alt="Logout"
                  style={{ cursor: 'pointer' }}
                />
              ) : (
                <>
                  <Link className="loginbtn" onClick={openLoginModal}>Login</Link>
                  <h2 className="pipecolor"> | </h2>
                  <img
                    className="headericon"
                    src={`${process.env.PUBLIC_URL}/logouticon.png`}
                    alt="Logout"
                  />
                </>
              )}
            </div>

            {/* Modals */}
            <LoginModal
              isOpen={isLoginModalOpen}
              onClose={closeLoginModal}
              onRegisterClick={openRegisterModal}
            />
            <RegisterModal
              isOpen={isRegisterModalOpen}
              onClose={closeRegisterModal}
            />
          </div>
      </div>
      </div>
    </header>
  );
};

export default Header;
